// Created by hejikun on 2017/10/25 0025.
let state = {
  show: false,
  type: ''
}

const actions = {}

const getters = {}

const mutations = {
  set_popup_show(state, arg) {
    state.show = arg
  },
  set_popup_type(state, arg) {
    state.type = arg
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
